<template>
  <div>
    <b-modal :active.sync="isSelectionModalActive" :width="640">
      <div class="card">
        <div class="card-content">
          <div class="content">
            <p v-for="item in formatedSelection" :key="item.id">
              {{ $t(item.id).replace(/#/g, '-') }}
            </p>
          </div>
        </div>
      </div>
    </b-modal>

    <b-field :label="$t(label)">
      <b-select
        @input="changeSelection"
        v-model="selectedFilter"
        :placeholder="$t('Selecciona')"
      >
        <option key="all" value="all">{{ $t(allLabel) }}</option>
        <option key="selected" value="selected">
          {{ $t('Solo seleccionadas') }}
        </option>
        <option key="all_except_selected" value="all_except_selected">
          {{ $t('Todos excepto seleccionados') }}
        </option>
        <option key="all_except_excluded" value="all_except_excluded">
          {{ $t('Todos excepto excluídos') }}
        </option>
      </b-select>
      <p class="control">
        <button
          @click="isSelectionModalActive = true"
          class="button is-primary"
        >
          {{ $t('Selección') }} ({{ selection.length }})
        </button>
      </p>
      <transition name="inputShow">
        <customized-tag-input
          v-if="isTagInputVisible"
          :options="options"
          v-model="selectedTags"
          @input="changeSelection"
        />
      </transition>
    </b-field>
  </div>
</template>

<script>
import CustomizedTagInput from '@/components/common/CustomizedTagInput.vue'

export default {
  components: { CustomizedTagInput },
  props: {
    options: Array,
    value: Array,
    label: {
      type: String,
      default: ''
    },
    allLabel: {
      type: String,
      default: 'Todos'
    }
  },
  data: () => ({
    selectedFilter: 'selected',
    filteredTags: [],
    isSelectionModalActive: false,
    selection: [],
    selectedTags: [],
    formatedSelection: []
  }),
  watch: {
    value: function(val) {
      let self = this
      self.selection = []
      self.selectedTags = []
      self.formatedSelection = []
      self.options.forEach(function(element) {
        if (val.includes(element.id)) {
          self.selection.push(element.id)
          self.selectedTags.push(element.id)
          self.formatedSelection.push(element)
        }
      })
    }
  },
  mounted() {},
  computed: {
    isTagInputVisible: function() {
      const visibleOptions = ['selected', 'all_except_selected']
      return visibleOptions.includes(this.selectedFilter)
    }
  },
  methods: {
    changeSelection(val) {
      let self = this
      switch (self.selectedFilter) {
        case 'all':
          self.selection = []
          self.formatedSelection = []
          self.options.forEach(function(element) {
            self.selection.push(element.id)
            self.formatedSelection.push(element)
          })
          break
        case 'selected':
          self.selection = []
          self.formatedSelection = []
          self.options.forEach(function(element) {
            if (self.selectedTags.includes(element.id)) {
              self.selection.push(element.id)
              self.formatedSelection.push(element)
            }
          })

          break
        case 'all_except_selected':
          self.selection = []
          self.formatedSelection = []
          self.options.forEach(function(element) {
            if (!self.selectedTags.includes(element.id)) {
              self.selection.push(element.id)
              self.formatedSelection.push(element)
            }
          })
          break
        default:
          self.selection = self.options
      }
      self.$emit('input', self.selection)
    }
  }
}
</script>
<style lang="scss">
#campos {
  .field {
    margin-bottom: 4em;

    &.has-addons {
      flex-wrap: wrap;
    }
    .select select {
      width: 100%;
    }
  }

  &.section section {
    input,
    select,
    button,
    .icon.is-left {
      font-size: 16px !important;
    }
    > div {
      width: 100%;
      margin: 60px 0;
      padding: 0 30px;
    }
    .tag {
      width: 48%;
      font-size: 16px;
    }
    select[multiple='multiple'] {
      height: 6.8em !important;
    }
  }
}

@media (max-width: 1024px) {
  .field .control {
    width: 100%;

    .select,
    select {
      width: 100%;
    }
  }
}
label.label {
  width: 100%;
}
.modal-content {
  .card {
    min-height: 50vh;
    border-radius: 10px;

    .card-content {
      height: 100%;
      padding-bottom: 0;
    }

    .content {
      position: unset;
      top: unset;
      transform: unset;
      font-weight: bold;
    }
  }
}
</style>
